/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationDetailRequestSchema } from "./comboCalculationDetailRequestSchema.ts";
import { comboCalculationItemRequestSchema } from "./comboCalculationItemRequestSchema.ts";

export const comboCalculationRequestRequestSchema = z.object({
	items: z.array(comboCalculationItemRequestSchema).optional(),
	combos: z.array(comboCalculationDetailRequestSchema).optional(),
});
